import type { FormField, FormSchema } from "@/lib/formSchema";

const LEGACY_FINANCIAL_LABELS: ReadonlyArray<[RegExp, string]> = [
  [/EBITDA\s*\/\s*SDE/g, "NOI"],
  [/EBITDA/g, "NOI"],
  [/SDE/g, "NOI"],
];

const LEGACY_KEY_LABELS: Readonly<Record<string, string>> = {
  ebitda_last_full_year: "NOI — last full year",
  ebitda: "NOI",
};

/**
 * Deal-submission financial metric labels now use NOI while legacy schemas and
 * payloads still carry EBITDA/SDE-flavored keys/tokens for import compatibility.
 */
export function dealSubmissionFinancialLabel(label: string | null | undefined, key?: string): string {
  const keyLabel = key ? LEGACY_KEY_LABELS[key] : undefined;
  let next = keyLabel ?? label ?? key ?? "";
  for (const [pattern, replacement] of LEGACY_FINANCIAL_LABELS) {
    next = next.replace(pattern, replacement);
  }
  return next;
}

export function normalizeDealSubmissionFinancialSchema(schema: FormSchema): FormSchema {
  return {
    ...schema,
    fields: schema.fields.map(normalizeField),
  };
}

function normalizeField(field: FormField): FormField {
  return {
    ...field,
    label: dealSubmissionFinancialLabel(field.label, field.name),
    helpText: field.helpText ? dealSubmissionFinancialLabel(field.helpText) : field.helpText,
    text: field.text ? dealSubmissionFinancialLabel(field.text) : field.text,
    fields: field.fields?.map(normalizeField),
  };
}
